import React from 'react';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import './About.css';

const About = () => {
    useScrollAnimation();
    
    return (
        <div className="about-page">
            <div className="container">
                <div className="section-header">
                    <span className="section-tag">Who We Are</span>
                    <h1 className="section-title">About</h1>
                    <h1 className="section-title">Nidharsanam Public Charitable Trust</h1>
                    <p className="section-description">Empowering communities through education, healthcare, and sustainable development since 2011</p>
                </div>

                <div className="about-content">
                    <div className="about-text scroll-animate">
                        <h2>Our Mission</h2>
                        <p>Nidharsanam Public Charitable Trust is dedicated to creating sustainable change in underserved communities worldwide. Through our innovative programs and dedicated volunteers, we focus on education, healthcare, environmental conservation, and economic empowerment.</p>
                        
                        <h2>Our Vision</h2>
                        <p>We envision a all where every individual has access to quality education, healthcare, and opportunities for economic growth, regardless of their circumstances.</p>
                        
                        <h2>Our Values</h2>
                        <ul className="values-list">
                            <li><strong>Compassion:</strong> We approach every situation with empathy and understanding</li>
                            <li><strong>Integrity:</strong> We maintain transparency in all our operations</li>
                            <li><strong>Innovation:</strong> We continuously seek better ways to serve communities</li>
                            <li><strong>Sustainability:</strong> We focus on long-term impact over short-term gains</li>
                            <li><strong>Collaboration:</strong> We believe in the power of partnerships</li>
                        </ul>
                    </div>

                    <div className="about-stats">
                        <div className="stat-box scroll-animate">
                            <i className="fas fa-project-diagram"></i>
                            <h3>15+</h3>
                            <p>Active Projects</p>
                        </div>
                        <div className="stat-box scroll-animate">
                            <i className="fas fa-hands-helping"></i>
                            <h3>100+</h3>
                            <p>Volunteers</p>
                        </div>
                        <div className="stat-box scroll-animate">
                            <i className="fas fa-globe"></i>
                            <h3>18+</h3>
                            <p>Districts</p>
                        </div>
                    </div>

                </div>
            </div>
            
            <div className="volunteers-section-wrapper">
                <div className="container">
                    <div className="volunteers-section">
                        <h2>Our Dedicated Team</h2>
                        <p className="volunteers-intro">Meet the passionate individuals who make our mission possible through their commitment and expertise.</p>
                        
                        <div className="volunteers-grid">
                            <div className="volunteer-card scroll-animate">
                                <div className="volunteer-icon">
                                    <img src={`${process.env.PUBLIC_URL}/images/volunteers/suresh.jpeg`} alt="W.V.P. Suresh Kumar" />
                                </div>
                                <h3>W.V.P. SURESH KUMAR</h3> 
                                <p className="degree">M.A, M.Sc, M.Ed, M.Phil, (KSPD Boys Higher Secondary)</p>
                            </div>
                            <div className="volunteer-card scroll-animate">
                                <div className="volunteer-icon">
                                    <img src={`${process.env.PUBLIC_URL}/images/volunteers/kokila.jpg`} alt="A.V. Kokila" />
                                </div>
                                <h3>A.V. KOKILA</h3>
                                <p className="degree">B.E</p>
                            </div>
                            <div className="volunteer-card scroll-animate">
                                <div className="volunteer-icon">
                                    <img src={`${process.env.PUBLIC_URL}/images/volunteers/kanchana.jpeg`} alt="M.K. Kanchana" />
                                </div>
                                <h3>M.K. KANCHANA</h3>
                                <p className="degree">B.C.A, B.Sc, B.Ed</p>
                            </div>
                            <div className="volunteer-card scroll-animate">
                                <div className="volunteer-icon">
                                    <img src={`${process.env.PUBLIC_URL}/images/volunteers/naresh.jpeg`} alt="P.N. Naresh Kumar" />
                                </div>
                                <h3>P.N. NARESH KUMAR</h3>
                                <p className="degree">B.com, M.Com, B.Ed</p>
                            </div>
                            <div className="volunteer-card scroll-animate">
                                <div className="volunteer-icon">
                                    <img src={`${process.env.PUBLIC_URL}/images/volunteers/nandhini.jpeg`} alt="P.N. Nandhini" />
                                </div>
                                <h3>P.N. NANDHINI</h3>
                                <p className="degree">B.Com</p>
                            </div>
                            <div className="volunteer-card scroll-animate">
                                <div className="volunteer-icon">
                                    <img src={`${process.env.PUBLIC_URL}/images/volunteers/venu.jpeg`} alt="S. Venu Akash" />
                                </div>
                                <h3>S. VENU AKASH</h3>
                                <p className="degree">B.Com</p>
                            </div>
                            <div className="volunteer-card scroll-animate">
                                <div className="volunteer-icon">
                                    <img src={`${process.env.PUBLIC_URL}/images/volunteers/prasanna.jpeg`} alt="S. Prasanna Kumari" />
                                </div>
                                <h3>S. PRASANNA KUMARI</h3>
                                <p className="degree">B.Com, M.Com</p>
                            </div>
                            <div className="volunteer-card">
                                <div className="volunteer-icon">
                                    <img src={`${process.env.PUBLIC_URL}/images/volunteers/abirami.jpeg`} alt="Abirami" />
                                </div>
                                <h3>ABIRAMI</h3>
                                <p className="degree">HSS</p>
                            </div>
                            <div className="volunteer-card">
                                <div className="volunteer-icon"><i className="fas fa-user-circle"></i></div>
                                <h3>ANURADHA</h3>
                                <p className="degree">B.Sc. in Agriculture</p>
                            </div>
                            <div className="volunteer-card">
                                <div className="volunteer-icon">
                                    <img src={`${process.env.PUBLIC_URL}/images/volunteers/amutha.jpeg`} alt="M. Amutha" />
                                </div>
                                <h3>M. AMUTHA</h3>
                                <p className="degree">HSS</p>
                            </div>
                            <div className="volunteer-card">
                                <div className="volunteer-icon">
                                    <img src={`${process.env.PUBLIC_URL}/images/volunteers/annakili.jpeg`} alt="S. Annakili" />
                                </div>
                                <h3>S.ANNAKILI</h3>
                                <p className="degree">HSS</p>
                            </div>
                            <div className="volunteer-card">
                                <div className="volunteer-icon"><i className="fas fa-user-circle"></i></div>
                                <h3>B. DIVYA</h3>
                                <p className="degree">B.Com</p>
                            </div>
                            <div className="volunteer-card">
                                <div className="volunteer-icon">
                                    <img src={`${process.env.PUBLIC_URL}/images/volunteers/nagalakshmi.jpeg`} alt="B. Nagalakshmi" />
                                </div>
                                <h3>B. NAGALAKSHMI</h3>
                                <p className="degree">B.A.Tamil</p>
                            </div>
                            <div className="volunteer-card">
                                <div className="volunteer-icon">
                                    <img src={`${process.env.PUBLIC_URL}/images/volunteers/vadivambal.jpeg`} alt="L. Vadivambal" />
                                </div>
                                <h3>L. VADIVAMBAL</h3>
                                <p className="degree">B.Com</p>
                            </div>
                            <div className="volunteer-card">
                                <div className="volunteer-icon"><i className="fas fa-user-circle"></i></div>
                                <h3>ARUL</h3>
                                <p className="degree">B.A, B.Ed, M.A, MBA</p>
                            </div>
                            <div className="volunteer-card">
                                <div className="volunteer-icon"><i className="fas fa-user-circle"></i></div>
                                <h3>JANANI</h3>
                                <p className="degree">B.Com</p>
                            </div>
                            <div className="volunteer-card">
                                <div className="volunteer-icon">
                                    <img src={`${process.env.PUBLIC_URL}/images/volunteers/diwakar.jpeg`} alt="N. Diwakar" />
                                </div>
                                <h3>N. DIWAKAR</h3>
                                <p className="degree">B.Com</p>
                            </div>
                            <div className="volunteer-card">
                                <div className="volunteer-icon"><i className="fas fa-user-circle"></i></div>
                                <h3>M. REVATHY</h3>
                                <p className="degree">M.A</p>
                            </div>
                            <div className="volunteer-card">
                                <div className="volunteer-icon"><i className="fas fa-user-circle"></i></div>
                                <h3>N. RAKSHANA</h3>
                                <p className="degree">B.Sc (Botany)</p>
                            </div>
                            <div className="volunteer-card">
                                <div className="volunteer-icon"><i className="fas fa-user-circle"></i></div>
                                <h3>S. RANJINI</h3>
                                <p className="degree">HSS</p>
                            </div>
                            <div className="volunteer-card">
                                <div className="volunteer-icon">
                                    <img src={`${process.env.PUBLIC_URL}/images/volunteers/soniya.jpeg`} alt="A. Soniya" />
                                </div>
                                <h3>A. SONIYA</h3>
                                <p className="degree">D.T.Ed</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
